import { ApplicantSubmissionDocumentSources } from 'src/ts/enums/applicant';

const applicantSubmissionDocumentSourceType = (
  source_type: ApplicantSubmissionDocumentSources
): ApplicantSubmissionDocumentSources => {
  switch (source_type) {
    case ApplicantSubmissionDocumentSources.BANK_LINKING:
      return ApplicantSubmissionDocumentSources.BANK_LINKING;
    case ApplicantSubmissionDocumentSources.CONNECTED_PAYROLL:
      return ApplicantSubmissionDocumentSources.CONNECTED_PAYROLL;
    case ApplicantSubmissionDocumentSources.TAX_RETURN_LINKING:
      return ApplicantSubmissionDocumentSources.TAX_RETURN_LINKING;
    default:
      return ApplicantSubmissionDocumentSources.CONNECTED_PAYROLL;
  }
};

export default applicantSubmissionDocumentSourceType;
